<div class="whiteboard-wrapper" [class.layout-top]="toolbarPosition === 'top'" [class.layout-left]="toolbarPosition === 'left'">
    <!-- Toolbar in alto se necessario -->
    <ng-container *ngIf="!config.whiteboardReadonly && toolbarPosition === 'top'">
        <div class="toolbar-filler-container">
            <ng-container *ngTemplateOutlet="toolbarContent; context: { vertical: false }"></ng-container>
        </div>
    </ng-container>
    <!-- Toolbar a sinistra se necessario -->
    <ng-container *ngIf="!config.whiteboardReadonly && toolbarPosition === 'left'">
        <div class="toolbar-filler-container vertical">
            <ng-container *ngTemplateOutlet="toolbarContent; context: { vertical: true }"></ng-container>
        </div>
    </ng-container>
    <!-- Main content area -->
    <div class="main-content-area">

        
        <!-- Whiteboard container -->
        <div #whiteboardContainer class="whiteboardContainer" (resized)="onResized($event)">
            <div class="whiteboardDiv"
                 [style.width.px]="canvasContainerWidth" 
                 [style.height.px]="canvasContainerHeight">        
                <div [hidden]="!showWhiteboard"
                     [style.width.px]="options.canvasWidth" 
                     [style.height.px]="options.canvasHeight">
                    <ng-whiteboard #whiteboardComponent
                        [class.readonly-mode]="config.whiteboardReadonly"
                        [options]="options"
                        [data]="config.whiteboardData || []"
                        [(selectedTool)]="toolSelected.value"
                        (save)="onSave($event)"
                        (dataChange)="onDataChange($event)"
                        (elementsAdded)="onElementsAdded($event)"
                        (elementsUpdated)="onElementsUpdated($event)"
                        (elementsSelected)="onElementsSelected($event)"
                        (elementsDeleted)="onElementsDeleted()"
                        (imageAdded)="onImageAdded($event)"
                        (relativeTransformChange)="onRelativeTransformChange($event)"
                        (configChanged)="onConfigChanged($event)"
                        (undoRedoStackSizes)="onUndoRedoStackChanged($event)"
                        (clear)="cleared()"
                        >
                    </ng-whiteboard>
                </div>
            </div>
        </div>
    
    
        <!-- Barra azioni sempre in basso -->
        <div class="whiteboard-actions toolbar-background" *ngIf="!config.whiteboardReadonly">
            <button mat-raised-button class="operator-button" *ngIf="(config.isReceiver || config.isGuest) && config.agencySettings.whiteboard.canShare"
                    [attr.aria-pressed]="config.whiteboardSharingEnabled"
                    [matTooltip]="(config.whiteboardSharingEnabled ? 'Whiteboard.StopRealtime' : 'Whiteboard.StartRealtime') | translate"
                    (click)="toggleRealtime()"
                    [disabled]="isToggling">
                <span class="font-icon-button material-symbols-outlined" 
                    [ngStyle]="{'color': isToggling ? '#999': config.whiteboardSharingEnabled ? 'var(--greenb80)' : ''}">
                    {{ config.whiteboardSharingEnabled ? 'autostop' : 'autoplay' }}
                </span>
            </button>        
            <button mat-raised-button class="operator-button" aria-label="Analize image" 
                    [matTooltip]="'Whiteboard.Send' | translate"
                    [disabled]="!config.whiteboardHasUnsavedChanges"
                    (click)="sendImage()">
                <span class="font-icon-button material-symbols-outlined">image_arrow_up</span>
            </button>
            <button mat-raised-button class="operator-button" aria-label="Send and close" 
                    [matTooltip]="'Whiteboard.SendAndClose' | translate"
                    [disabled]="!config.whiteboardHasUnsavedChanges"
                    (click)="sendImageAndCloseWhiteboard()">
                <span class="font-icon-button material-symbols-outlined">tab_close_right</span>
            </button>  
            <button mat-raised-button class="operator-button" aria-label="Analize image" 
                    *ngIf="config.agencySettings.whiteboard.iaEnabled"
                    [matTooltip]="'Whiteboard.Analize' | translate"
                    (click)="analyzeImage($event)">
                <span class="font-icon-button material-symbols-outlined">detection_and_zone</span>
            </button>
        </div>

        <div class="whiteboard-actions toolbar-background" *ngIf="config.whiteboardReadonly">
            <button mat-raised-button class="operator-button" *ngIf="(config.isReceiver || config.isGuest) && config.agencySettings.whiteboard.canShare"
                    [matTooltip]="'Whiteboard.TakeControl' | translate"
                    (click)="TakeControl()"
                    [disabled]="isToggling">
                <span class="font-icon-button material-symbols-outlined" [class.spin-slow]="isToggling">
                    change_circle
                </span>
            </button>  

        </div>
    </div>
</div>

<!-- Template riutilizzabile per la toolbar -->
<ng-template #toolbarContent let-vertical="vertical">
   <div class="toolbar-filler toolbar-background" [class.vertical]="vertical" *ngIf="!config.whiteboardReadonly">
      <div class="not-wrapped" [class.vertical]="vertical">
        <div class="toolbar-selector">
            <mat-form-field class="toolbar-form" appearance="fill" subscriptSizing="dynamic">
                <mat-select panelClass="panel-tool-select-option" [(value)]="toolSelected" (selectionChange)="onToolChange()">
                    <mat-select-trigger>
                        <span class="font-icon-button material-symbols-outlined tool-icon-selected"
                              [matTooltip]=" 'Whiteboard.ttpSelectedTool' | translate : {'tool':'Whiteboard.' + toolSelected.value | translate}">
                            {{toolSelected.icon}}
                        </span>
                    </mat-select-trigger>
                    <mat-option class="item-option" *ngFor="let tool of tools" [value]="tool" [disabled]="isToolDisabled(tool)">
                        <span *ngIf="config.agencySettings.whiteboard.canEdit || !tool.forEdit">
                            <mat-icon class="font-icon-button material-symbols-outlined tool-icon">
                            {{tool.icon}}
                        </mat-icon>
                        {{'Whiteboard.' + tool.value | translate}}
                        </span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        
        <button mat-raised-button class="operator-button" aria-label="Palette Tool" *ngIf="config.agencySettings.whiteboard.canEdit"
                [matTooltip]="'Whiteboard.ColorSelector' | translate"
                ngx-colors-trigger
                [(ngModel)]="currentStrokeColor"
                [hideTextInput]="true"
                [acceptLabel]="'POPUP.ACCEPT' | translate"
                [cancelLabel]="'POPUP.CANCEL' | translate"
                (change)="colorChange('strokeColor', $event)">
            <span class="font-icon-button material-symbols-outlined palette-button"
                  [style.background]="currentStrokeColor">palette</span>
        </button>

        <button mat-raised-button class="operator-button" aria-label="Zoom-in"
                [disabled]="config.whiteboardTransformData.zoomRelative >= maxZoom"
                [matTooltip]="'Whiteboard.zoom-plus' | translate"
                [matTooltipDisabled]="config.isMobilePhone" (click)="zoomIn()">
            <span class="font-icon-button material-symbols-outlined">zoom_in</span>
        </button>
        
        <button mat-raised-button class="operator-button" aria-label="Zoom-out"
                [disabled]="config.whiteboardTransformData.zoomRelative == 1"
                [matTooltip]="'Whiteboard.zoom-out' | translate"
                [matTooltipDisabled]="config.isMobilePhone" (click)="zoomOut()">
            <span class="font-icon-button material-symbols-outlined">zoom_out</span>
        </button>

      </div>

      <div class="not-wrapped" [class.vertical]="vertical" >
        <app-whiteboard-properties-menu *ngIf="config.agencySettings.whiteboard.canEdit"
            [class.hidden]="hidePropertiesButton"
            [activeTool]="toolSelected.value"
            [selectedElements]="selectedElements"
            [properties]="drawingProperties"
            (hidden)="hidePropertiesButton=$event"
            [matTooltip]="!hidePropertiesButton ? ('Whiteboard.drawingProperties' | translate) : ''"
            (propertiesChange)="onWhiteboardPropertiesChange($event)">
        </app-whiteboard-properties-menu>

        <button mat-raised-button class="operator-button" aria-label="Undo" 
                [disabled]="undoDisabled"
                [matTooltip]="'Whiteboard.Undo' | translate"
                (click)="undo()">
            <span class="font-icon-button material-symbols-outlined">undo</span>
        </button>
        
        <button mat-raised-button class="operator-button" aria-label="Redo"
                [disabled]="!undoRedoStackSizes.redoSize"  
                [matTooltip]="'Whiteboard.Redo' | translate"
                (click)="redo()">
            <span class="font-icon-button material-symbols-outlined">redo</span>
        </button>
        
        <button mat-raised-button class="operator-button" aria-label="Reset"
                [disabled]="resetDisabled"  
                [matTooltip]="'Whiteboard.Reset' | translate"
                (click)="reset()">
            <span class="font-icon-button material-symbols-outlined">reset_image</span>
        </button>
        </div>
    </div>
</ng-template>
